// extracted by mini-css-extract-plugin
export default {"container":"CardContentComponent_container__zgwX9","count":"CardContentComponent_count__CkoAf"};